'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (FreeSampleSale, $) {
    'use strict';

    var $dom = {};
    var $state = {};

    var cacheDom = function cacheDom() {
      $dom.container = $('#free-sample-sale');
      $dom.form = $dom.container.find('form');
      $dom.emailInput = $dom.container.find('form .email-address input');
      $dom.button = $dom.container.find('[name="checkout"]');

      $state.variantId = $dom.form.find('[name="id"]').val();
      $state.discountCode = $dom.form.find('[name="discount"]').val();
      $state.listId = $dom.form.find('[name="klavio_id"]').val();
    };

    var handleFormSubmit = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                event.preventDefault();
                $dom.button.attr('disabled', true);
                _context.next = 5;
                return trackEmail();

              case 5:
                _context.next = 7;
                return validateProduct();

              case 7:

                setTimeout(function () {
                  gotoCheckout();
                }, 1500);
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                $dom.button.attr('disabled', false);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined, [[0, 10]]);
      }));

      return function handleFormSubmit(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var addToCart = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function addToCart() {
        return _ref2.apply(this, arguments);
      };
    }();

    var gotoCheckout = function gotoCheckout() {
      window.location = '/cart/' + $state.variantId + ':1?discount=' + $state.discountCode + '&email=' + encodeURIComponent($dom.emailInput.val()) + '&checkout';
    };

    var validateProduct = function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!$state.variantId || $state.variantId === '')) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('Product data missing');

              case 2:
                if (!(!$state.discountCode || $state.discountCode === '')) {
                  _context3.next = 4;
                  break;
                }

                throw new Error('Discount data missing');

              case 4:
                return _context3.abrupt('return', $state);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, undefined);
      }));

      return function validateProduct() {
        return _ref3.apply(this, arguments);
      };
    }();

    var validateEmail = function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    var trackEmail = function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var email;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                email = $dom.emailInput.val();

                if (!(email.trim().split('').length == 0)) {
                  _context4.next = 3;
                  break;
                }

                throw new Error('Email is required');

              case 3:
                if (validateEmail(email)) {
                  _context4.next = 5;
                  break;
                }

                throw new Error('Invalid Email');

              case 5:
                return _context4.abrupt('return', $.post('https://a.klaviyo.com/ajax/subscriptions/subscribe', {
                  g: $state.listId,
                  '$email': email
                }).done(function (data) {
                  console.log(data);
                }));

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, undefined);
      }));

      return function trackEmail() {
        return _ref4.apply(this, arguments);
      };
    }();

    var setExitIntentCookie = function setExitIntentCookie() {
      Cookies.set('free-sample-exit-intent', 'true', { expires: 1 });
    };

    var hasSeenExitIntentToday = function hasSeenExitIntentToday() {
      return Cookies.get('free-sample-exit-intent') === 'true';
    };

    var showModal = function showModal() {
      if (hasSeenExitIntentToday()) return null;
      // need to check if exit intent modal is enabled
      var exitModal = $('[free-sample-modal-exit]').length;
      exitModal > 0 && window.Modal.show('free-sample-modal');
    };

    var bindUIActions = function bindUIActions() {
      $dom.form.on('submit', handleFormSubmit);
      $.exitIntent('enable');
      $(document).on('MODAL_SHOW', function (event, _ref5) {
        var name = _ref5.name;

        if (hasSeenExitIntentToday()) return null;
        if (name === 'free-sample-modal') return setExitIntentCookie();
      });
      $(document).one('exitintent', function () {
        $.exitIntent('disable');
        showModal();
      });
    };

    FreeSampleSale.init = function () {
      cacheDom();
      bindUIActions();
    };
  })(window.FreeSampleSale = window.FreeSampleSale || {}, _jquery2.default);
};